/**
 * Yönetim kurulu — sıra ve üye listesi. Görseller ve isimler hazır olunca güncelleyin.
 * @typedef {{ role: string, name: string, image?: string | null }} BoardMember
 * @typedef {{
 *   key: string,
 *   sectionTitle?: string | null,
 *   members: BoardMember[],
 * }} BoardSection
 */

/** Yer tutucu fotoğraf (harici istek yok). */
export const BOARD_MEMBER_PLACEHOLDER_IMAGE =
    'data:image/svg+xml,' +
    encodeURIComponent(
        `<svg xmlns="http://www.w3.org/2000/svg" width="280" height="340" viewBox="0 0 280 340"><rect fill="#e9ecef" width="280" height="340"/><text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" fill="#868e96" font-family="system-ui,sans-serif" font-size="13">Fotoğraf</text></svg>`,
    );

/**
 * i18n `managementBoard.fallbackSections` (returnObjects) → BoardSection[].
 * @param {unknown} raw
 * @returns {BoardSection[]}
 */
export function mapFallbackSectionsFromI18n(raw) {
    if (!Array.isArray(raw)) return [];
    return raw
        .map((s) => {
            if (!s || typeof s !== 'object') return null;
            const key = String(/** @type {{ key?: unknown }} */ (s).key ?? '');
            if (!key) return null;
            const st = /** @type {{ sectionTitle?: unknown }} */ (s).sectionTitle;
            const sectionTitle =
                typeof st === 'string' && st.trim() ? st : null;
            const rawMembers = /** @type {{ members?: unknown }} */ (s).members;
            const members = Array.isArray(rawMembers)
                ? rawMembers
                      .filter((m) => m && typeof m === 'object')
                      .map((m) => {
                          const o = /** @type {{ role?: unknown, name?: unknown }} */ (
                              m
                          );
                          return {
                              role: String(o.role ?? ''),
                              name: String(o.name ?? ''),
                              image: null,
                          };
                      })
                : [];
            return { key, sectionTitle, members };
        })
        .filter((x) => x != null);
}
